import tokens from "@irati/auth/services/tokens";
import { toString as loginRefreshQuery } from "@irati/auth/services/queries/loginRefresh";
import sentry from "../../../sentry";
import logout from "./logout";
import graph from "../../../graph";
import GenericErrorCodes from "../../../errorCodes/Generic";
var inFlight = null;
export default function (err, accessToken) {
    if (!tokens.hasResumed()) {
        // Condition just for native, web (through token.ts) will never reach this point
        inFlight = tokens.resume();
    }
    if (!inFlight) {
        if (!accessToken) {
            return logout(err);
        }
        inFlight = requestToken(accessToken).then(function (token) {
            tokens.set({ accessToken: token });
            return true;
        });
    }
    return inFlight
        .catch(function (refreshError) {
        sentry.captureException(refreshError);
        tokens.clear();
        return logout(err);
    })
        .finally(function (d) {
        inFlight = null;
        return d;
    });
}
export function requestToken(accessToken) {
    var variables = {
        expiredToken: accessToken
    };
    var options = {
        unAuth: true,
        useErrorHandler: false,
        sentryIgnoreError: [GenericErrorCodes.PBERRForbiddenTokenExpired]
    };
    return graph({ query: loginRefreshQuery, variables: variables }, options).then(function (res) {
        return res.loginRefresh.accessToken;
    });
}
